import { t } from "@hakili/i18n";
import { Button } from "@hakili/ui";
import { useEffect } from "react";

/**
 * `EQUIPE-GESTURES` R3 (designer's review `7f265f3d`, C3): **« Annuler » is ONE control across the bank's modals.** The quiet text
 * button (the kit's ghost), set AFTER the act it cancels: the Équipe frames had it as a link in one modal and a tinted button in
 * the next, first in one and last in another. Every modal's footer says « Annuler » through this and nothing else.
 */
export function ModalCancel(props: {
  readonly onClick: () => void;
  readonly testId?: string;
  /**
   * `EQUIPE-GESTURES` R7 (designer's review e23449ec): the window opens with the focus on the quiet way out, ring included (a script focus
   * after a pointer click is not « visible » unless asked). Needs a `testId` to be found by.
   */
  readonly focusOnOpen?: boolean;
}): React.JSX.Element {
  const { focusOnOpen, testId } = props;
  useEffect(() => {
    if (focusOnOpen !== true || testId === undefined) return;
    const own = document.querySelector<HTMLElement>(`[data-testid="${testId}"]`);
    // The bank theme draws the ring from this hook (a script focus after a click is not :focus-visible).
    own?.setAttribute("data-initial-focus", "true");
    own?.focus({ focusVisible: true } as FocusOptions);
  }, [focusOnOpen, testId]);
  return (
    <Button
      variant="ghost"
      {...(props.testId === undefined ? {} : { "data-testid": props.testId })}
      onClick={props.onClick}
    >
      {t("bank.modal.annuler")}
    </Button>
  );
}
